var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 35,
    viewBox: "0 0 40 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.7088 35C1.98646 35 1.3544 34.7398 0.812641 34.2193C0.27088 33.6989 0 33.0917 0 32.3978V10.1487C0 9.48368 0.27088 8.88373 0.812641 8.34882C1.3544 7.81392 1.98646 7.54647 2.7088 7.54647H9.34537L12.6411 3.77323H25.2822V8.9777H30.6546V14.1822H36.1174V32.3978C36.1174 33.0917 35.839 33.6989 35.2822 34.2193C34.7254 34.7398 34.1008 35 33.4086 35H2.7088ZM18.0587 28.6679C20.2257 28.6679 22.0467 27.9595 23.5214 26.5428C24.9962 25.126 25.7336 23.3767 25.7336 21.2949C25.7336 19.1842 24.9962 17.4277 23.5214 16.0254C22.0467 14.6231 20.2257 13.9219 18.0587 13.9219C15.8615 13.9219 14.0331 14.6231 12.5734 16.0254C11.1136 17.4277 10.3837 19.1842 10.3837 21.2949C10.3837 23.3767 11.1136 25.126 12.5734 26.5428C14.0331 27.9595 15.8615 28.6679 18.0587 28.6679ZM18.0587 26.0657C16.614 26.0657 15.4251 25.6103 14.4921 24.6995C13.5591 23.7887 13.0926 22.6539 13.0926 21.2949C13.0926 19.9071 13.5591 18.765 14.4921 17.8686C15.4251 16.9723 16.614 16.5242 18.0587 16.5242C19.4733 16.5242 20.6546 16.9723 21.6027 17.8686C22.5508 18.765 23.0248 19.9071 23.0248 21.2949C23.0248 22.6539 22.5508 23.7887 21.6027 24.6995C20.6546 25.6103 19.4733 26.0657 18.0587 26.0657ZM33.3634 10.1053V6.37546H29.4808V3.77323H33.3634V0H36.0722V3.77323H40V6.37546H36.0722V10.1053H33.3634Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamera);
export default __webpack_public_path__ + "static/media/icon-camera.8180f6e0143d197c744458557e8ac6f8.svg";
export { ForwardRef as ReactComponent };